import { Component, Output, EventEmitter } from '@angular/core';
import { HttpStatusCode } from '@angular/common/http';
import { GeolocationStatus, LocalStorageKey } from 'projects/store/src/app/enums';
import { NavigatorPermissionStatus } from 'projects/store/src/app/enums/navigator-permission-status.enum';
import { RequestService } from 'projects/store/src/app/services/api/v1/request.service';
import { LocalStorageService, UtilService, CustomMessageService } from "library";
import {ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-sales-validate-geolocalization',
  templateUrl: './sales-validate-geolocalization.component.html'
})
export class SalesValidateGeolocalizationComponent {
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Geolocalización'];
  position: { latitude: number, longitude: number } | null = null;
  geolocationStatus!:string;
  constructorService: any;
  storeData: any;
  requestId: string;
  GeolocationStatus = GeolocationStatus;
  @Output() nextStepEvent = new EventEmitter();


  constructor(private requestService: RequestService,
              private localStorageService: LocalStorageService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
   }

  ngOnInit() {
    this.storeData = this.localStorageService.get(LocalStorageKey.data).store.setting;
    this.verifyEnableGeolocation(this.requestId)
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  verifyEnableGeolocation(requestId: string) {
    if(this.storeData.enabled_active_geolocation) {
      this.utilService.disablePageLoading();
      this.checkHTML5Position(requestId);
    }else{
      this.onNextStep()
    }
  }

  checkHTML5Position(requestId: string) {

    navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {

        switch (permissionStatus.state) {
          case NavigatorPermissionStatus.prompt:
            this.geolocationStatus = GeolocationStatus.instructions;
            break;
            case NavigatorPermissionStatus.granted:
              this.setHTML5Position(requestId);
            break;
          case NavigatorPermissionStatus.denied:
            this.geolocationStatus = GeolocationStatus["not-accepted"];
            break;
          default:
            this.geolocationStatus = GeolocationStatus["not-accepted"];
        }

    });
  }

  setHTML5Position(requestId: string) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.position = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          this.checkGeolocationAccepted(requestId, { ...this.position})
        },
        () => {
          this.checkGeolocationNotAccepted()
        },
      );
    } else {
      this.geolocationStatus = GeolocationStatus["not-support"]
    }
  }

  checkGeolocationAccepted(requestId: string, position: { latitude: number, longitude: number}) {

    this.requestService.checkGeolocation(requestId, { ...position}).subscribe(
      resp => {
        if(resp.status == HttpStatusCode.Ok) {
          if(resp.body.data.approved == false && this.storeData.enabled_check_geolocation == true) {
            this.geolocationStatus = GeolocationStatus["distance-lock"]
          }else{
            this.onNextStep();
          }
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      }, error => {
        this.customMessageService.responseNoticeHandler(error);
      }
    )

  }

  checkGeolocationNotAccepted() {
    this.geolocationStatus = GeolocationStatus["not-accepted"]
  }

  goToIndexWeb(){
    this.router.navigate(
      ['/inicio']
    );
  }

}
